// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__31oO5","inner":"Footer_inner__1PIpN"};